<template>
    <div>
        <TableList ref="tableList" v-bind="getData"></TableList>
    </div>
</template>

<script>
import { HttpFindInboundPlan } from "@/service/transferplan";
import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from "vuex";
export default {
    components: {
        TableList,
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters("dictionary", ["getProductList"]),
        getData() {
            return {
                initFormData: {
                	search:{
                	}
                },
                ajaxRequest: HttpFindInboundPlan,
                startUp: true,
                Searchs: {
                    show: true,
                    style: "border:none;",
                    // labelWidth: 'auto',
                    align: "left",
                },
                SearchsData: [
                    {
                        label: "入库计划单号",
                        tag: "vInput",
                        key: "EQ_inboundPlanOrderNo",
                        style: "width: 150px",
                        show: true,
                    },
                    {
                        label: "来源单号",
                        tag: "vInput",
                        key: "EQ_sourceNo",
                        style: "width:150px",
                        show: true,
                    },
                    {
                        label: "Shipment ID",
                        tag: "vInput",
                        key: "EQ_shipmentId",
                        style: "width: 150px",
                        show: true
                    },
                    {
                        label: "Reference ID",
                        tag: "vInput",
                        key: "EQ_referenceId",
                        style: "width: 150px",
                        show: true
                    }
                    // {
                    //     label: "项目",
                    //     tag: "Select",
                    //     options: this.getProductList,
                    //     key: "EQ_lineId",
                    //     style: "width: 160px",
                    //     show: true
                    // },
                ],
                columns: [
                    {
                        title: "入库计划单号",
                        key: "inboundPlanOrderNo"
                    },
                    {
                        title: "来源单号",
                        key: "sourceNo"
                    },
                    {
                        title: "仓库",
                        key: "orgWarehouseCode",
                        render: (h, {row}) => {
                            return <div>{row.orgWarehouseName}({row.orgWarehouseCode})</div>
                        }
                    },
                    {
                        title: "项目",
                        key: "lineName"
                    },
                    {
                        title: "操作",
                        align: "center",
                        width: 80,
                        render: (h, { row }) => {
                            return (
                                <div>
                                    <Button size="small" type="primary" onClick={this.handleSelect.bind(this, row)}>选择</Button>
                                </div>
                            );
                        },
                    },
                ],
            };
        },
    },
    methods: {
        handleSelect (item) {
            this.$emit('on-select', item);
            this.$emit('on-close');
        }
    }
};
</script>

<style>
</style>